<template>
    <div class="home">
      <!--<j-header></j-header>-->
      <Banner></Banner>
      <el-row>
        <!--<el-col :xs="24" :sm="24">-->
          <!--<div class="grid-content">-->
            <!--<h3 class="title"><i><img src="../assets/icons/product.png" alt=""></i>产品分类</h3>-->
          <!--</div></el-col>-->
        <!--<el-col :span="16">-->
<!--        <el-col :xs="24" :sm="8" class="rightbar">-->
<!--          <div class="grid-content">-->
<!--            <side-bar></side-bar>-->
<!--          </div></el-col>-->
        <el-col :xs="24" :sm="24">
          <div class="grid-content">
            <h3 class="title"><i><img src="../assets/icons/product.png" alt=""></i>Product Category</h3>
            <pro-item></pro-item>
          </div></el-col>
      </el-row>
      <el-row>
        <el-col :xs="24" :sm="24">
          <div class="grid-content">
            <h3 class="title"><i><img src="../assets/icons/news.png" alt=""></i>News</h3>
        </div></el-col>
        <!--<el-col :span="14">-->
        <el-col :xs="24" :sm="14">
          <div class="grid-content">
            <news></news>
          </div></el-col>
        <el-col :xs="24" :sm="10">
          <div class="grid-content">
            <div class="company">
              <img src="../assets/company.jpg" alt="" width="100%">
              <p class="more">>> Other news</p>
            </div>
          </div></el-col>
      </el-row>
    </div>
</template>

<script>
  import JHeader from '../components/Header.vue'
  import Banner from '../components/home/Banner.vue'
  import ProItem from '../components/home/proItem.vue'
  import SideBar from '../components/home/SideBar.vue'
  import News from '../components/home/News.vue'
  export default {
    name: 'home',
    components: {
      JHeader, Banner, ProItem, SideBar, News
    },
    data () {
      return {
      }
    }
  }
</script>
<style type="text/scss" rel="stylesheet/scss" lang="scss" scoped>
  .home{
    margin-top: 16px;
  }
  .rightbar{
    float: right;
    box-sizing: border-box;
    padding-top: 30px;
    display: none;
  }
  .title{
    max-width: 1200px;
    margin: auto;
    color: #c80000;
    font-size: 18px;
    font-weight: bold;
    text-align: left;
    line-height: 30px;
    padding: 15px 0 15px;
    i{
      display: inline-block;
      vertical-align: middle;
      width: 50px;
      height: 40px;
    }
  }
  .company{
    border: solid 1px #999999;
    .more{
      height: 50px;
      line-height: 50px;
      padding-right: 20px;
      background: rgba(246,245,243,.8);
      color: #c80000;
      text-align: right;
      position: relative;
      margin-top: -50px;
      cursor: pointer;
      &:hover{
        opacity: .5;
      }
    }
  }
  @media only screen and (max-width: 768px){
    .home{
      margin-top: 0;
    }
    .title{
      color: #000;
      text-align: center;
      i{
        display: none
      }
    }
    .rightbar{
      padding: 0;
    }
    .company{
      margin-bottom: 30px;
      .more{
        text-align: center;
        color: #333333;
        height: 35px;
        line-height: 35px;
        padding-right: 0;
        margin-top: -35px;
        font-size: 14px;
      }
    }
  }
</style>
<style>
  .el-row{
  max-width: 1200px;
  margin: auto;
}
  .home .grid-content{
    padding: 0 15px;
    /*border: 1px solid red;*/
  }
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue